<template>
  <div class="wrapper">
    <br /><br />
    <div class="messagebar">
      <div class="photoSide">
        <div>
          <el-image
            class="photo"
            :src="studentDetail.avatar || defalutHead"
            fit="contain"
          ></el-image>
          <div>{{ studentDetail.mobile }}</div>
          <div class="button">{{ studentDetail.userName }}</div>
        </div>
      </div>
      <div class="detailSide">
        <div class="detailLine">
          <div class="detailBar">
            <div class="key">身份证号</div>
            <div class="value">{{ studentDetail.idCard }}</div>
          </div>
          <div class="detailBar">
            <div class="key">手机号</div>
            <div class="value">{{ studentDetail.mobile }}</div>
          </div>
        </div>
        <div class="detailLine">
          <div class="detailBar">
            <div class="key">性别</div>
            <div class="value">{{ studentDetail.sex }}</div>
          </div>
          <div class="detailBar">
            <div class="key">分组</div>
            <div class="value">{{ studentDetail.groupName }}</div>
          </div>
        </div>
        <div class="detailLine">
          <div class="detailBar">
            <div class="key">参与考试次数</div>
            <div class="value">{{ studentDetail.examNum }}</div>
          </div>
          <div class="detailBar">
            <div class="key">及格次数</div>
            <div class="value">{{ studentDetail.passNum }}</div>
          </div>
        </div>
        <div class="detailLine">
          <div class="detailBar">
            <div class="key">及格率</div>
            <div class="value">{{ studentDetail.passRate * 100 }}%</div>
          </div>
          <div class="detailBar">
            <div class="key">最高分</div>
            <div class="value">{{ studentDetail.maxScore }}</div>
          </div>
        </div>
      </div>
    </div>
    <br /><br />
    <div class="analysisBar" style="display: flex">
      <div
        style="flex: 1; display: block; height: 580px; margin: 10px"
        id="correctRateAnalysis"
      ></div>
      <div
        style="flex: 1; display: block; height: 580px; margin: 10px"
        id="radarAnalysis"
      ></div>
    </div>
    <br /><br /><br />
    <span style="font-size: 1.4em">参与考试的时间</span>&emsp;
    <el-date-picker
      v-model="scoreTimeRange"
      type="daterange"
      align="right"
      unlink-panels
      range-separator="至"
      start-placeholder="开始日期"
      end-placeholder="结束日期"
      :picker-options="scorePickerOptions"
      value-format="yyyy-MM-dd"
      @change="
        (e) => {
          [searchCondition.scoreStartDate, searchCondition.scoreEndDate] = e;
          getStudentScoreTransformation();
        }
      "
    >
    </el-date-picker>
    <br />
    <br />
    <div class="analysisBar" style="display: flex">
      <div
        style="flex: 1; display: block; height: 580px; margin: auto"
        id="scoreChange"
      ></div>
    </div>
    <br /><br /><br />
    <div class="tableContainer">
      <h2 class="title">参与考试的试卷</h2>
      <el-table :data="examList" border style="width: 100%">
        <el-table-column type="index" label="序号" width="180">
        </el-table-column>
        <el-table-column prop="exName" label="试卷名称" width="180">
        </el-table-column>
        <el-table-column prop="status" label="状态"> </el-table-column>
        <el-table-column prop="score" label="得分"> </el-table-column>
        <el-table-column prop="scoreRatio" label="得分比"> </el-table-column>
        <el-table-column prop="startTime" label="考试时间"> </el-table-column>
        <el-table-column prop="timeUse" label="用时"> </el-table-column>
      </el-table>
      <el-pagination
        small
        :current-page.sync="examSearchCondition.pageNumber"
        :page-size.sync="examSearchCondition.pageSize"
        :total="examSearchCondition.total"
        @current-change="getStudentExamList"
        hide-on-single-page
      >
      </el-pagination>
      <br /><br /><br />
      <h2>学习记录</h2>
      <el-table :data="learnList" border style="width: 100%">
        <el-table-column type="index" label="序号" width="180">
        </el-table-column>
        <el-table-column prop="courseTitle" label="课程名称" width="180">
        </el-table-column>
        <el-table-column prop="cataLogTitle" label="视频名称">
        </el-table-column>
        <el-table-column prop="totalLearnTime" label="总时长">
        </el-table-column>
        <el-table-column prop="lastLearnTime" label="开始时间">
        </el-table-column>
        <el-table-column prop="ratio" label="学习进度"> </el-table-column>
      </el-table>
      <el-pagination
        small
        :current-page.sync="learnSearchCondition.pageNumber"
        :page-size.sync="learnSearchCondition.pageSize"
        :total="learnSearchCondition.total"
        @current-change="getStudentLearnList"
        hide-on-single-page
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import {
  getStudentAnalysis,
  getStudentExamList,
  getStudentLearnList,
  getStudentScoreTransformation,
  getStudentDetail,
} from "@/api/examination/student.js";
import * as echarts from "echarts";

export default {
  data() {
    return {
      defalutHead: require("../../assets/headdefault.png"),
      studentDetail: {},
      examList: [],
      learnList: [],
      searchCondition: {
        scoreStartDate:
          new Date().getDate() > 7
            ? new Date().getFullYear() +
              "-" +
              (new Date().getMonth() - -1) +
              "-" +
              (new Date().getDate() - 7)
            : new Date().getFullYear() +
              "-" +
              new Date().getMonth() +
              "-" +
              (new Date().getDate() + 23),
        scoreEndDate:
          new Date().getFullYear() +
          "-" +
          (new Date().getMonth() - -1) +
          "-" +
          new Date().getDate(),
      },
      scoreTimeRange: ["", ""],
      scorePickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      learnSearchCondition: {
        pageNumber: 1,
        pageSize: 10,
        id: this.$route.query.id,
        total: 0,
      },
      examSearchCondition: {
        pageNumber: 1,
        pageSize: 10,
        id: this.$route.query.id,
        total: 0,
      },
    };
  },
  created() {},
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      //   this.getStudentDetail();
      //   this.getStudentAnalysis();
      //   this.getStudentExamList();
      //   this.getStudentLearnList();
      //   this.getStudentScoreTransformation();
      Promise.all([
        this.getStudentDetail(),
        this.getStudentAnalysis(),
        this.getStudentExamList(),
        this.getStudentLearnList(),
        this.getStudentScoreTransformation(),
      ]).then(() => {
        console.log("全请求完");
      });
    },
    getStudentDetail() {
      return getStudentDetail({ id: this.$route.query.id }).then((data) => {
        this.studentDetail = data;
      });
    },
    getStudentAnalysis() {
      getStudentAnalysis({ id: this.$route.query.id }).then((data) => {
        setTimeout(() => {
          let chart = echarts.init(
            document.getElementById("correctRateAnalysis")
          );
          chart.setOption(data.correctRateHistogramRoot);
          let chart2 = echarts.init(document.getElementById("radarAnalysis"));
          chart2.setOption(data.radarOption);
        }, 200);
      });
    },
    getStudentExamList() {
      getStudentExamList(this.examSearchCondition).then((data) => {
        // this.studentDetail = data;
        this.examList = data.rows;
        this.examSearchCondition.total = data.total;
      });
    },
    getStudentLearnList() {
      getStudentLearnList(this.learnSearchCondition).then((data) => {
        this.learnList = data.rows;
        this.learnSearchCondition.total = data.total;
      });
    },
    getStudentScoreTransformation() {
      getStudentScoreTransformation({
        id: this.$route.query.id,
        startDate: this.searchCondition.scoreStartDate,
        endDate: this.searchCondition.scoreEndDate,
      }).then((data) => {
        setTimeout(() => {
          let chart = echarts.init(document.getElementById("scoreChange"));
          chart.setOption(data.lineRoot);
        }, 200);
      });
    },
  },
};
</script>

<style scoped lang="less">
.wrapper {
  padding: 30px;
  width: 100%;
  text-align: center;
  display: block;
  margin: auto;
  background: #fff;
  box-sizing: border-box;
  .messagebar {
    display: flex;
    border: 1px solid #ccc;
    border-bottom: none;
    width: 1000px;
    border-right: none;
    margin: 30px auto;
    .photoSide {
      width: 20%;
      text-align: center;
      border-bottom: 1px solid #ccc;
      align-items: center;
      justify-content: center;
      display: flex;
      .photo {
        width: 100px;
        height: 100px;
        border-radius: 50%;
      }
    }
  }
  .detailSide {
    width: 80%;
    // flex: 1;
    border-left: 1px solid #ccc;
    .detailLine {
      width: 100%;
      display: flex;
    }
    .detailBar {
      display: flex;
      flex: 1;
      width: 50%;
      align-items: center;
      justify-content: space-between;
      border-bottom: 1px solid #ccc;
      height: 48px;
      .key {
        padding: 15px 10px;
        text-align: right;
        width: 100px;
      }
      .value {
        flex: 1;
        padding: 14px 10px;
        text-align: left;
        border-left: 1px solid #ccc;
        border-right: 1px solid #ccc;
        height: 100%;
        display: block;
        width: 100%;
        position: relative;

        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        z-index: 1;
        &:hover {
          overflow: visible;
          z-index: 10;
          background: #fff;
          white-space: initial;
          height: auto;
          // text-overflow: clip;
        }
      }
    }
  }
}
</style>
